(function () {
  var SIZE_ORDER_SML = ['S', 'M', 'L'];
  var SIZE_ORDER_SMLXL = ['S', 'M', 'L', 'XL'];

  var FIT_LABELS = ['Tight', 'Tight / Regular', 'Regular', 'Regular / Loose', 'Loose'];

  var SIZE_ALIASES = {
    S: ['S', 'SMALL'],
    M: ['M', 'MEDIUM'],
    L: ['L', 'LARGE'],
    XL: ['XL', 'X-LARGE', 'XLARGE', 'X LARGE'],
  };

  function normalizeOption(value) {
    return String(value || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, ' ');
  }

  function getBaseSize(heightCm, weightKg, sizeSet) {
    var h = Number(heightCm);
    var w = Number(weightKg);

    if (!h || !w) return null;

    if (sizeSet === 'smlxl') {
      if (h < 155) {
        return w <= 70 ? 'S' : 'M';
      }
      if (h <= 170) {
        return w <= 70 ? 'S' : 'M';
      }
      if (h <= 180) {
        if (w < 60) return 'S';
        if (w <= 80) return 'M';
        return 'L';
      }
      if (h <= 190) {
        return w < 80 ? 'M' : 'L';
      }
      return w < 85 ? 'L' : 'XL';
    }

    if (h < 155) {
      return w <= 70 ? 'S' : 'M';
    }
    if (h <= 170) {
      return w <= 70 ? 'S' : 'M';
    }
    if (h <= 185) {
      if (w < 60) return 'S';
      if (w <= 80) return 'M';
      return 'L';
    }
    return w < 80 ? 'M' : 'L';
  }

  function applyFitPreference(baseSize, fitLevel, sizeSet) {
    var sizes = sizeSet === 'smlxl' ? SIZE_ORDER_SMLXL : SIZE_ORDER_SML;
    var idx = sizes.indexOf(baseSize);
    if (idx === -1) idx = 1;

    var shift = 0;
    if (fitLevel <= 1) shift = -1;
    else if (fitLevel >= 3) shift = 1;

    idx = Math.max(0, Math.min(sizes.length - 1, idx + shift));
    return sizes[idx];
  }

  function sizeMatchesLetter(optionValue, sizeLetter) {
    var normalized = normalizeOption(optionValue);
    var aliases = SIZE_ALIASES[sizeLetter] || [sizeLetter];
    return aliases.some(function (alias) {
      return normalized === alias || normalized.indexOf(alias) === 0;
    });
  }

  function selectProductSize(sizeLetter) {
    var fieldsets = document.querySelectorAll('.product-form__input--pill, .product-form__input--swatch');
    var matched = false;

    fieldsets.forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      var legendText = legend ? legend.textContent.toLowerCase() : '';
      if (legendText.indexOf('size') === -1 && legendText.indexOf('beden') === -1) return;

      fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
        if (sizeMatchesLetter(input.value, sizeLetter)) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          matched = true;
        }
      });
    });

    if (!matched) {
      document.querySelectorAll('.product-form__input--dropdown select').forEach(function (select) {
        Array.from(select.options).forEach(function (option) {
          if (sizeMatchesLetter(option.value, sizeLetter)) {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            matched = true;
          }
        });
      });
    }

    return matched;
  }

  function initModal(modal) {
    var form = modal.querySelector('[data-find-my-size-form]');
    if (!form) return;

    var sizeSet = modal.dataset.sizeSet || 'sml';
    var heightInput = form.querySelector('[data-find-my-size-height]');
    var weightInput = form.querySelector('[data-find-my-size-weight]');
    var fitInput = form.querySelector('[data-find-my-size-fit]');
    var fitLabel = form.querySelector('[data-find-my-size-fit-label]');
    var resultWrap = form.querySelector('[data-find-my-size-result]');
    var resultSize = form.querySelector('[data-find-my-size-result-size]');
    var applyBtn = form.querySelector('[data-find-my-size-apply]');
    var errorEl = form.querySelector('[data-find-my-size-error]');

    function updateFitLabel() {
      if (!fitInput || !fitLabel) return;
      var idx = parseInt(fitInput.value, 10) || 0;
      fitLabel.textContent = FIT_LABELS[idx] || FIT_LABELS[2];
    }

    if (fitInput) {
      fitInput.addEventListener('input', function () {
        updateFitLabel();
        fitInput.setAttribute('aria-valuenow', fitInput.value);
      });
      updateFitLabel();
    }

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      if (errorEl) errorEl.hidden = true;

      var height = parseFloat(heightInput && heightInput.value);
      var weight = parseFloat(weightInput && weightInput.value);
      var fitLevel = parseInt(fitInput && fitInput.value, 10);

      if (!height || height < 100 || height > 230) {
        if (errorEl) {
          errorEl.textContent = 'Please enter a valid height (100–230 cm).';
          errorEl.hidden = false;
        }
        return;
      }

      if (!weight || weight < 30 || weight > 200) {
        if (errorEl) {
          errorEl.textContent = 'Please enter a valid weight (30–200 kg).';
          errorEl.hidden = false;
        }
        return;
      }

      var base = getBaseSize(height, weight, sizeSet);
      var recommended = applyFitPreference(base, fitLevel, sizeSet);

      if (resultSize) resultSize.textContent = recommended;
      if (resultWrap) resultWrap.hidden = false;
      if (applyBtn) {
        applyBtn.dataset.size = recommended;
        applyBtn.hidden = false;
      }
    });

    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        var size = applyBtn.dataset.size;
        if (!size) return;
        selectProductSize(size);
        var closeBtn = modal.querySelector('[id^="ModalClose-"]');
        if (closeBtn) closeBtn.click();
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-find-my-size-modal]').forEach(initModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
